import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import Select from "react-select";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import { AddSubCategoryApi } from "./SubCategory.action";
// import { getWarehouseApi } from "../Warehouse/Warehouse.action";
import { getCategoryWithWarehouseApi } from "../categories/Catagory.action";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";


const AddSubCategory = (props) => {
  // const [warehouseId, setWarehouseId] = useState();
  // const [warehouseName, setWarehouseName] = useState();
  const [retaurantId, setRestaurantId] = useState();
  const [restaurantName, setRestaurantName] = useState();
  const [CategoryId, setCategoryId] = useState();
  const [Categoryname, setCategoryName] = useState();
  const [subCategory, setSubCategoryName] = useState("");


  function SaveSubCategory() {
    props.AddSubCategoryApi({
      retaurantId: retaurantId,
      restaurantName: restaurantName,
      categoryId: CategoryId,
      categoryname: Categoryname,
      subCategoryName: subCategory,
      // wareHouseId: warehouseId,
    },
      showSuccessAlert,
      showErrorAlert,
    );
    setRestaurantId("");
    setRestaurantName("");
    setCategoryId("");
    setCategoryName("");
    setSubCategoryName("");
  }

  // const handleChangeWarehouse = (selectedOption) => {
  //   setWarehouseId(selectedOption.value);
  //   setWarehouseName(selectedOption.label);
  //   props.getCategoryWithWarehouseApi(selectedOption.value);
  // };
  // const getWarehouseList = !_.isEmpty(props.warehouseList.data) && props.warehouseList.data.map((x) => {
  //   let data = { value: x._id, label: x.businessName };
  //   return data;
  // });

  const handleChangeRestaurant = (selectedOption) => {
    setRestaurantId(selectedOption.value);
    setRestaurantName(selectedOption.label);
    props.getCategoryWithWarehouseApi(selectedOption.value);
  };
  const getRetaurantList = props.restaurantDataList?.length ? props.restaurantDataList.map(x => ({
    value: x._id,
    label: x.restaurantName,
  })) : [];

  const handleChangeCategory = (selectedOption) => {
    setCategoryId(selectedOption.value);
    setCategoryName(selectedOption.label);
  };
  const getCategoryList = props.categoryListByWarehouseId.data?.length ? props.categoryListByWarehouseId.data.map(x => ({
    value: x._id,
    label: x.name,
  })) : [];

  useEffect(() => {
    // props.getWarehouseApi();
    props.getRestaurantData();
    props.setHeading("New Sub-Category");
  }, []);

  return (
    <>
      {props.isFetchingRestaurant || props.isAddingSubCategory ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Company *</b></Form.Label>
                <Select
                  value={{ label: restaurantName }}
                  placeholder="Select Company"
                  onChange={handleChangeRestaurant}
                  options={getRetaurantList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Category *</b></Form.Label>
                <Select
                  placeholder="Select Category"
                  isDisabled={_.isEmpty(props.categoryListByWarehouseId) || _.isEmpty(retaurantId)}
                  onChange={handleChangeCategory}
                  options={getCategoryList}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Sub-Category Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Sub-Category Name"
                  onMouseLeave={(e) => setSubCategoryName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(restaurantName) || _.isEmpty(Categoryname) || _.isEmpty(subCategory) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SaveSubCategory}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddSubCategoryApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddSubCategoryApi(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
    // getWarehouseApi: () => dispatch(getWarehouseApi()),
    getRestaurantData: () => dispatch(getRestaurantData()),
    getCategoryWithWarehouseApi: (id) => dispatch(getCategoryWithWarehouseApi(id)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingSubCategory: state.SubCategoryReducer.isAddingSubCategory,
  // warehouseList: state.WarehouseReducer.warehouseList,
  // isFetchingWarehouseList: state.WarehouseReducer.isFetchingWarehouseList,
  categoryListByWarehouseId: state.CategoryReducer.categoryListByWarehouseId,
  isFetchingCategoryByWarehouseId: state.CategoryReducer.isFetchingCategoryByWarehouseId,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
  isFetchingRestaurant: state.ResturantReducer.isFetchingRestaurant,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSubCategory);
